import React from 'react'
import styled from 'styled-components'
import { FaFacebookF, FaInstagram, FaTimes } from "react-icons/fa";
import { AiOutlineSearch } from "react-icons/ai";
import { SidebarData } from './SidebarData';
import SidebarMenu from './SidebarMenu';
import { FontSize1, NolKoma7to1rem } from '../../GlobalStyles';
import { useNavigate } from 'react-router-dom';

const Container = styled.aside`
    background-color: white;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 3;
    /* width: 100%;
    max-width: 500px; */
    transform: ${({ sidebar }) => sidebar ? '' : 'translateX(-100%)'};
    transition: transform 500ms;
    @media (min-width: 800px) {
        display: none;
    }
`
const CloseIcon = styled(FaTimes)`
    font-size: 1.3rem;
    color: white;
    position: absolute;
    top: 1rem;
    right: 1rem;
    cursor: pointer;
`
const MenuContainer = styled.div`
    margin-top: 2rem;
    display: grid;
    gap: 1.2rem;
    padding: 0 10px;
`
const BottomContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 2rem;
    padding: 0 1rem;
`
const IconWrap = styled.div`
    display: flex;
    align-items: center;
    & > *:first-child {
        margin-right: 1rem;
    }
    svg {
        font-size: 1.5rem;
    }
`
const SelectWrap = styled.div`
    select {
        font-size: 0.8rem;
        outline: none;
        padding: 6px 12px;
        cursor: pointer;
    }
`
const TopMenu = styled.div`
    background-color: black;
    padding: 2rem 1rem 1rem;
    display: grid;
    gap: 1.5rem;
`
const SearchMenu = styled.div`
    display: flex;
    align-items: center;
    max-width: 250px;
    border-bottom: 1px solid white;
    input {
        font-size: ${FontSize1};
        width: 100%;
        padding: 5px 10px;
        border: none;
        outline: none;
        background-color: transparent;
        color: white;
        &::placeholder {
            color: white;
        }
    }
    svg {
        font-size: 2rem;
        color: white;
    }
`
const Dropship = styled.p`
    font-size: ${NolKoma7to1rem};
    text-transform: uppercase;
    color: white;
    cursor: pointer;
    width: fit-content;
    word-spacing: 10px;
`
export default function SidebarContainer({ toggleSidebar, sidebar }) {
  const navigate = useNavigate()
  const onClick = () => {
    toggleSidebar()
    navigate('/lists')
  }
  return (
    <Container sidebar={sidebar}>
        <CloseIcon onClick={toggleSidebar}/>
        <TopMenu>
            <SearchMenu>
                <input type="search" placeholder='Search Products' />
                <AiOutlineSearch onClick={onClick}/>
            </SearchMenu>
            <Dropship onClick={onClick}>
                dropship: login | register
            </Dropship>
            <Dropship onClick={onClick}>login | register</Dropship>
        </TopMenu>
        <MenuContainer>
            {
                SidebarData.map((menu, idx) => (
                    <SidebarMenu toggleSidebar={toggleSidebar} menu={menu} key={idx} />
                ))
            }
        </MenuContainer>
        <BottomContainer>
            <IconWrap>
                <FaFacebookF/>
                <FaInstagram/>
            </IconWrap>
            <SelectWrap>
                <select name="choose" id="choose">
                    <option value="myr">MYR</option>    
                    <option value="sgd">SGD</option>    
                    <option value="bnd">BND</option>    
                </select>
            </SelectWrap>
        </BottomContainer>
    </Container>
  )
}
